jQuery(function ($) {
	var isTouchDevice = "ontouchstart" in window;
	if (isTouchDevice) {
		$("body").addClass("touch-support");
	} else {
		$("body").addClass("no-touch-support");
	}

	$(window).on("keyup", function (e) {
		if (e.ctrlKey == true) {
			if (e.shiftKey == false && e.keyCode === 76) {
				// L, for Layout like in Sketch.
				$("body").toggleClass("show-grid");
			}
			if (e.shiftKey == true && e.keyCode === 76) {
				$("body").toggleClass("show-breakpoint");
			}
		}
	});

	$("body").toggleClass(
		"is-mobile",
		!!window.navigator.userAgent.match(/mobile/gi) || "ontouchstart" in window
	);

	// var splashPlayed = false;
	// if (Cookies.get("hcma-splash")) {
	// 	splashPlayed = JSON.parse(Cookies.get("hcma-splash"));
	// }
	// if (!splashPlayed) {
	// 	Cookies.set("hcma-splash", JSON.stringify(true), { expires: 30 });
	// 	$(".splash video").on("ended", function () {
	// 		setTimeout(function () {
	// 			$(".splash").fadeOut(400, function () {
	// 				$(this).remove();
	// 			});
	// 		}, 500);
	// 	});
	// 	// Clean up if video too slow or never loads.
	// 	setTimeout(function () {
	// 		$(".splash").remove();
	// 	}, 7000);
	// } else {
	// 	$(".splash").remove();
	// }
	// $(".splash").click(function () {
	// 	$(".splash").fadeOut(400, function () {
	// 		$(this).remove();
	// 	});
	// });

	$(".accordion-header:not(.external-link)").click(function () {
		if ($(window).width() <= 600) {
			$(this)
				.parent(".accordion")
				.toggleClass("active")
				.find(".accordion-body")
				.slideToggle(function () {
					if ($(this).parent(".accordion").hasClass("experiment-map")) {
						setupMap();
					}
					if (
						$(this).parent(".accordion").hasClass("active") &&
						$(this).parents(".team-section").length > 0
					) {
						history.replaceState(
							{},
							"",
							"#" +
								$(this)
									.parent(".accordion")
									.find(".accordion-cards li:first-child a")
									.data("member")
						);
					}
					if (
						$(this).parent(".accordion").hasClass("active") &&
						$(this).parents(".job-postings").length > 0
					) {
						history.replaceState(
							{},
							"",
							"#" + $(this).parents(".job-postings").attr("id")
						);
					}
				});
		}
		// goToHomeSection('experiment-map');
	});

	$(".filter .toggle").click(function () {
		console.log("open filter");
		window.filterTest = [$(this), $(this).parents(".filter")];
		$(this).parents(".filter").toggleClass("active");
		return false;
	});

	$("body").click(function (e) {
		if ($(e.target).parents(".site-navigation, .filter").length <= 0) {
			$(".menu-toggle a, .menu-content, .filter").removeClass("active");
		}
	});

	$("[data-member]").click(function () {
		var $profile = $("." + $(this).data("member"));
		$(".member, .team-nav-bar a").removeClass("active");
		$profile.addClass("active");
		$(this).addClass("active");
		history.replaceState({}, "", "#" + $(this).data("member"));
		return false;
	});

	$(".member-pic").click(function () {
		var $members = $(".team-nav-bar [data-member]");
		var $member = $(
			$members.get(
				($members.index($(".team-nav-bar [data-member].active")) + 1) %
					$members.length
			)
		);
		$member.trigger("click");
		return false;
	});
	$(".member-first").click(function () {
		$(".team-nav-bar [data-member]").first().trigger("click");
	});

	$(".scrapbook .slides").css(
		"width",
		$(".scrapbook .slide").length * $(".scrapbook .slide").width() -
			($(".scrapbook .slide").length - 1) *
				($(window).height() < 650 ? 75 : 150) +
			40
	);

	if ($(".tilt-count-minute, .tilt-count-second").length > 0) {
		var tiltMinutes = 0;
		var tiltSeconds = 0;
		var tiltTimer = setInterval(function () {
			if (tiltSeconds % 8 === 0) {
				tiltMinutes += 1;
			}
			tiltSeconds += 1;
			$(".tilt-count-minute").html(
				tiltMinutes < 10 ? "0" + tiltMinutes : tiltMinutes
			);
			var seconds = (tiltSeconds - 1) % 60;
			$(".tilt-count-second").html(seconds < 10 ? "0" + seconds : seconds);

			if (tiltMinutes >= 16) {
				// TODO: See about looping this with a pause in between.
				clearInterval(tiltTimer);
			}
		}, 25);
	}

	// $('.open-asset-grid').packery({
	//   itemSelector: '.asset-item',
	// });

	var $tiltMomentMasonry = null;
	$(".tilt-split .choose-split").click(function () {
		var $split = $(this).parents(".tilt-split");
		if ($(window).width() > 768) {
			window.scrollTo(0, $(".tilt-split").offset().top);
		}
		if ($(this).parent().hasClass("tilt-what")) {
			$split.removeClass("choose-tilt-discover");
			$split.toggleClass("choose-tilt-what");
			var added = 0;
			$(".trigger-animation-start").each(function () {
				var toAdd = this;
				if (!$(toAdd).attr("class").match("active")) {
					added += 1;
					setTimeout(function () {
						$(toAdd).attr("class", $(toAdd).attr("class") + " active");
					}, 250 * added);
				}
			});
			window.scrollTo(0, $(".tilt-what").position().top);
			// $(".tilt-discover h1").stick_in_parent({
			//   offset_top: $('#masthead').height() + $('#wpadminbar').height(),
			//   // recalc_every: 1
			// });
			// $(".tilt-what h1").trigger("sticky_kit:detach");
		} else {
			$split.removeClass("choose-tilt-what");
			$split.toggleClass("choose-tilt-discover");
			setTimeout(function () {
				$tiltMomentMasonry = $(".tilt-moments").packery({
					itemSelector: ".tilt-moment",
				});
			}, 350);
			// $(".tilt-what h1").stick_in_parent({
			//   offset_top: $('#masthead').height() + $('#wpadminbar').height(),
			//   // recalc_every: 1
			// });
			// $(".tilt-discover h1").trigger("sticky_kit:detach");
			window.scrollTo(0, $(".tilt-discover").position().top);
		}
		// window.scrollTo(0, $split.position().top);
		// $('body').trigger('sticky_kit:recalc');
		return false;
	});
	$(".discover-tilt-moments-cta").click(function () {
		var $split = $(this).parents(".tilt-split");
		$split.removeClass("choose-tilt-what");
		$split.toggleClass("choose-tilt-discover");
		setTimeout(function () {
			$tiltMomentMasonry = $(".tilt-moments").packery({
				itemSelector: ".tilt-moment",
			});
		}, 350);
		window.scrollTo(0, $split.position().top);
	});
	if ($(".tilt-split").length > 0) {
		$(window).on("scroll", function () {
			if (window.scrollY > $(".tilt-split").offset().top) {
				$(".tilt-split").addClass("stuck");
			} else {
				$(".tilt-split").removeClass("stuck");
			}
			if (
				window.scrollY >
				$(".tilt-split").offset().top +
					$(".tilt-split").height() -
					$(window).height()
			) {
				$(".tilt-split").addClass("bottom");
			} else {
				$(".tilt-split").removeClass("bottom");
			}
		});
	}

	$(".tilt-moment:not(.more-moments) .main-content").click(function (e) {
		var $this = $(this).parent();
		$this.addClass("visited");
		if ($this.hasClass("active")) {
			$this.removeClass("active");
		} else {
			$(".tilt-moment.active").removeClass("active");
			$this.addClass("active");
		}
		$tiltMomentMasonry.packery();
		return false;
	});
	$(".tilt-moments").click(function (e) {
		if ($(e.target).parents(".card").length <= 0) {
			$(".tilt-moment.active").removeClass("active");
			$tiltMomentMasonry.packery();
			return false;
		}
	});
	$(".tilt-moments").on("click", ".more-moments", function () {
		var $this = $(this);
		$tiltMomentMasonry
			.packery("remove", $this)
			.packery("layout")
			.one("layoutComplete", function () {
				$.get($this.attr("href"), function (data, response) {
					var $items = $(data).find(".tilt-moment");
					$tiltMomentMasonry.append($items).packery("appended", $items);
				});
			});
		return false;
	});

	if ($(".tilt-moments").length > 0) {
		$("body").on("mousemove", function (e) {
			$(".tilt-moment").each(function () {
				var $this = $(this);
				var pageX = e.originalEvent.pageX || e.originalEvent.touches[0].pageX;
				var pageY = e.originalEvent.pageY || e.originalEvent.touches[0].pageY;
				var diffX = pageX - $this.offset().left - $this.width() / 2;
				var diffY = pageY - $this.offset().top - $this.height() / 2;

				var angle = Math.atan(diffY / diffX);
				var distance = diffX / Math.cos(angle);

				// Bubble effect.
				var num = 0.5 - Math.abs(distance) / 1500;
				if (!$(this).hasClass("active")) {
					$(this)
						.find(".main-content")
						.css("transform", "scale(" + (0.2 + (num > 0 ? num : 0)) + ")");
				}
			});
			return true;
		});
	}

	$(window).on("scroll", function () {
		if (
			$(".tilt-split").hasClass("choose-tilt-what") ||
			$(".tilt-split").hasClass("choose-tilt-discover")
		) {
			var added = 0;
			var side = $(".tilt-split").hasClass("choose-tilt-what")
				? ".tilt-what"
				: ".tilt-discover";
			$(side + " .trigger-animation").each(function () {
				if ($(window).height() * (4 / 5) > this.getBoundingClientRect().top) {
					var toAdd = this;
					if (!$(toAdd).attr("class").match("active")) {
						added += 1;
						setTimeout(function () {
							$(toAdd).attr("class", $(toAdd).attr("class") + " active");
						}, 250 * added);
					}
				}
			});
		}
	});

	var perspectiveFixed = $(".single-perspective .first");
	if (perspectiveFixed.length > 0) {
		$(window).on("scroll", function () {
			perspectiveFixed.toggle(window.scrollY <= $(window).height() * 1.25);
		});
	}

	function setupMap() {
		var lat = $("#map").data("lat");
		var lng = $("#map").data("lng");
		var map = L.map("map", {
			dragging: false,
			touchZoom: false,
			scrollWheelZoom: false,
			doubleClickZoom: false,
			boxZoom: false,
			tap: false,
			keyboard: false,
			zoomControl: false,
			attributionControl: false,
		}).setView([lat, lng], 13);

		// Helpful for finding nice tiles: https://leaflet-extras.github.io/leaflet-providers/
		// L.tileLayer('http://korona.geog.uni-heidelberg.de/tiles/roadsg/x={x}&y={y}&z={z}').addTo(map);
		L.tileLayer("https://tiles.wmflabs.org/bw-mapnik/{z}/{x}/{y}.png").addTo(
			map
		);

		L.popup({
			closeButton: false,
			closeOnClick: false,
		})
			.setLatLng([lat, lng])
			.setContent($("#map").data("popup"))
			.openOn(map);
	}

	$(".media-tabs .tab:not(.soundcloud):not(.youtube)").click(function () {
		$(
			$(".media-gallery .slide")
				.removeClass("active playing")
				.get($(this).index())
		).addClass("active");
		$(".media-tabs .tab").removeClass("active");
		$(".media-gallery .slide iframe").remove();
		$(".media-gallery .slide .text").show();
		$(this).addClass("active");
		return false;
	});

	$(".slide .play").click(function () {
		var $slide = $(this).parents(".slide");
		var url = $(this).attr("href");
		$slide.find(".text").fadeOut("fast", function () {
			if (url.match("soundcloud")) {
				$(
					'<iframe scrolling="no" frameborder="no" src="https://w.soundcloud.com/player/?url=' +
						url +
						'&amp;auto_play=true&amp;hide_related=true&amp;show_comments=true&amp;show_user=true&amp;show_reposts=false&amp;visual=true"></iframe>'
				).appendTo($slide);
			} else {
				$(
					'<iframe src="https://www.youtube.com/embed/' +
						url.replace("https://www.youtube.com/watch?v=", "") +
						'?rel=0&showinfo=0&modestbranding=1&autoplay=1" frameborder="0" allowfullscreen></iframe>'
				).appendTo($slide);
			}
			$slide.addClass("playing");
		});
		return false;
	});

	// $("[data-cabinet-item]").click(function () {
	// 	var itemSlug = $(this).data("cabinet-item");
	// 	if (!$('[data-cabinet-item="' + itemSlug + '"]').hasClass("active")) {
	// 		history.replaceState({}, "", "#" + itemSlug);

	// 		$("[data-cabinet-item]").removeClass("active");
	// 		$('[data-cabinet-item="' + itemSlug + '"]').addClass("active");

	// 		$(".cabinet-item.active").fadeOut(200, function () {
	// 			$(".cabinet-item.active").removeClass("active");
	// 			$("#cabinet-" + itemSlug)
	// 				.fadeIn(200)
	// 				.addClass("active");

	// 			$("html, body").animate(
	// 				{ scrollTop: $("#cabinet-" + itemSlug).position().top },
	// 				250
	// 			);
	// 		});
	// 	}
	// 	return false;
	// });
	$(".cabinet-item .previous, .cabinet-item .next").click(function () {
		var $items = $(".cabinet-item");
		var index = $items.index($(this).parents(".cabinet-item"));
		if ($(this).hasClass("next")) {
			index += 1;
		} else {
			index -= 1;
		}
		if (index < 0) {
			index = $items.length - 1;
		}
		$nextItem = $($items.get(index % $items.length));
		history.replaceState(
			{},
			"",
			"#" + $nextItem.attr("id").replace("cabinet-", "")
		);

		$(".cabinet-item.active").fadeOut(200, function () {
			$(".cabinet-item.active").removeClass("active");
			$nextItem.fadeIn(200).addClass("active");
		});
	});

	if ($("#cabinet-" + window.location.hash.replace("#", "")).length > 0) {
		$(".cabinet-item.active").removeClass("active");
		$("#cabinet-" + window.location.hash.replace("#", "")).addClass("active");
		window.scrollTo(
			0,
			$("#cabinet-" + window.location.hash.replace("#", "")).position().top
		);
	}

	if ($("#artist-" + window.location.hash.replace("#", "")).length > 0) {
		$(".artist.active").removeClass("active");
		$("#artist-" + window.location.hash.replace("#", "")).addClass("active");
	}

	$(".js-goto-application").click(function () {
		$("html, body").animate(
			{ scrollTop: $("#apply").offset().top - $(".sub-nav").height() },
			250
		);
	});

	$("body.page-id-2 .sub-nav a").click(function () {
		var path = $(this).attr("href").replace("/about/", "");
		if (path.charAt(0) === "#") {
			$("html, body").animate(
				{ scrollTop: $(path).offset().top - $(".sub-nav").height() },
				250
			);
		}
	});

	var pano = null;
	$(".three-sixty .toggle").click(function () {
		$(this).parents(".three-sixty").toggleClass("active");
		if (pano === null) {
			pano = new pano2vrPlayer("pano-viewer");
			pano.readConfigUrl($(this).parents(".three-sixty").data("viewer"));
			// hide the URL bar on the iPhone
			// hideUrlBar();
			// add gyroscope controller
			gyro = new pano2vrGyro(pano, "pano-viewer");
		}
	});

	if ($(".artist-slider").length > 0) {
		console.log("hey");
		var artistSliderSelected = false;
		$(".artist-slider .thumb").on(
			isTouchDevice ? "touchstart" : "mousedown",
			function () {
				artistSliderSelected = true;
				return false;
			}
		);
		$("body").on(isTouchDevice ? "touchend" : "mouseup", function () {
			if (artistSliderSelected) {
				artistSliderSelected = false;
				return false;
			}
		});
		$("body").on(isTouchDevice ? "touchmove" : "mousemove", function (e) {
			if (artistSliderSelected) {
				var pageX = e.originalEvent.pageX || e.originalEvent.touches[0].pageX;
				var progress = Math.max(
					Math.min(
						(pageX - $(".artist-slider").offset().left) /
							$(".artist-slider").width(),
						1
					),
					0
				);
				$(".artist-slides").scrollLeft(
					(18 + 220 * $(".artist").length - $("body").width()) * progress
				);
				$(".artist-slider .progress").css("width", progress * 100 + "%");
				return false;
			}
		});
		$(".artist-slides").on("scroll", function () {
			var progress =
				$(".artist-slides").scrollLeft() /
				(18 + 220 * $(".artist").length - $("body").width());
			$(".artist-slider .progress").css("width", progress * 100 + "%");
		});
	}

	var $slides = $(".overlapping-slider .slide");
	$slides.hover(function () {
		$slides.removeClass("hover bump");
		$(this).addClass("hover");
		$(".overlapping-slider .slide:nth-child(2)").toggleClass(
			"bump",
			$slides.index($(this)) == 2
		);
	});

	if ($(".scrapbook-slider").length > 0) {
		var sliderSelected = false;
		$(".scrapbook-slider .thumb").on(
			isTouchDevice ? "touchstart" : "mousedown",
			function () {
				sliderSelected = true;
				return false;
			}
		);
		$("body").on(isTouchDevice ? "touchend" : "mouseup", function () {
			if (sliderSelected) {
				sliderSelected = false;
				return false;
			}
		});
		$("body").on(isTouchDevice ? "touchmove" : "mousemove", function (e) {
			if (sliderSelected) {
				var pageX = e.originalEvent.pageX || e.originalEvent.touches[0].pageX;
				var progress = Math.min(
					(pageX - $(".scrapbook-slider").offset().left) /
						$(".scrapbook-slider").width(),
					1
				);
				$(".scrapbook").scrollLeft(
					progress * ($(".scrapbook .slides").width() + 170 - $("body").width())
				);
				$(".scrapbook-slider .progress").css("width", progress * 100 + "%");
				return false;
			}
		});
		$(".scrapbook").on("scroll", function () {
			var progress = Math.min(
				$(".scrapbook").scrollLeft() /
					($(".scrapbook .slides").width() + 170 - $("body").width()),
				1
			);
			$(".scrapbook-slider .progress").css("width", progress * 100 + "%");
		});
		$(".scrapbook-slider").toggle(
			$(".scrapbook .slides").width() + 170 > $("body").width()
		);
		$(window).on("resize", function () {
			$(".scrapbook-slider").toggle(
				$(".scrapbook .slides").width() + 170 > $("body").width()
			);
		});
	}

	if ($(".experiments-slider").length > 0) {
		var start = 0;
		var step = 100 / $(".experiments .slide").length;
		var experiments = $(".experiments .slide").map(function (
			index,
			experiment
		) {
			var object = {
				name: $(experiment).data("name"),
				link: $(experiment).data("link"),
				start: start,
				stop: start + step,
			};
			start += step;
			return object;
		});
		var sliderSelected = false;
		var noScroll = false;
		$(".experiments .button").attr(
			"href",
			$(".experiments .slide:first-of-type").data("link")
		);
		var setCurrentExperiment = function (progress) {
			var experiment = null;
			for (var i = 0; i < experiments.length; i++) {
				if (
					progress * 100 >= experiments[i].start &&
					progress * 100 <= experiments[i].stop
				) {
					$(".experiments-slider .tooltip").html(experiments[i].name);
					$(".experiments .button").attr("href", experiments[i].link);
					experiment = experiments[i];
					break;
				}
			}
			return experiment;
		};
		$(".experiments-slider .thumb").on(
			isTouchDevice ? "touchstart" : "mousedown",
			function () {
				sliderSelected = true;
				return false;
			}
		);
		$("body").on(isTouchDevice ? "touchend" : "mouseup", function () {
			if (sliderSelected) {
				sliderSelected = false;
				var experiment = setCurrentExperiment(
					Math.min(
						$(".slides").scrollLeft() /
							($(".slide").width() * (experiments.length - 1)),
						1
					)
				);
				noScroll = true;
				var progress = experiments.index(experiment) / (experiments.length - 1);
				// $('.slides').scrollLeft(progress * ($('.slide').width() * (experiments.length - 1)));
				$(".slides").animate(
					{
						scrollLeft:
							progress * ($(".slide").width() * (experiments.length - 1)),
					},
					250
				);
				setTimeout(function () {
					noScroll = false; // Ensure that we don't move the scroll bar.
				}, 350);
				return false;
			}
		});
		$("body").on(isTouchDevice ? "touchmove" : "mousemove", function (e) {
			if (sliderSelected) {
				var pageX = e.originalEvent.pageX || e.originalEvent.touches[0].pageX;
				var progress = Math.min(
					(pageX - $(".experiments-slider").offset().left) /
						$(".experiments-slider").width(),
					1
				);
				$(".slides").scrollLeft(
					progress * ($(".slide").width() * (experiments.length - 1))
				);
				$(".experiments-slider .progress").css("width", progress * 100 + "%");
				setCurrentExperiment(progress);
				return false;
			}
		});
		$(".slides").on("scroll", function () {
			if (!noScroll) {
				var progress = Math.min(
					$(".slides").scrollLeft() /
						($(".slide").width() * (experiments.length - 1)),
					1
				);
				$(".experiments-slider .progress").css("width", progress * 100 + "%");
				setCurrentExperiment(progress);
			}
		});
	}

	if ($(window).width() <= 600 && $(".accordion-cards").length > 0) {
		$(".accordion-cards").each(function () {
			var $this = $(this);
			var start = 0;
			var step = 100 / $this.find(".accordion-card").length;
			var cards = $this.find(".accordion-card").map(function (index, card) {
				var object = {
					i: index,
					card: $(card),
					start: start,
					stop: start + step,
				};
				start += step;
				return object;
			});
			var debounce = null;
			// $this.parent('.accordion-body').find('.more-accordion-contents').html( $('.accordion-contents-' + $this.find('li:first-of-type .accordion-card').data('accordion-contents')).html() );
			$this
				.parent(".accordion-body")
				.find(".more-accordion-contents *")
				.remove();
			$this
				.parent(".accordion-body")
				.find(".more-accordion-contents")
				.prepend(
					$(
						".accordion-contents-" +
							$this
								.find("li:first-of-type .accordion-card")
								.data("accordion-contents")
					).clone(true)
				);
			$this.on("scroll", function () {
				clearTimeout(debounce);
				$this
					.parent(".accordion-body")
					.find(".more-container")
					.removeClass("active")
					.find(".more")
					.slideUp();
				var progress = Math.min(
					$this.scrollLeft() /
						($this.find(".accordion-card").width() * (cards.length - 1)),
					1
				);
				var card = null;
				for (var i = 0; i < cards.length; i++) {
					if (
						progress * 100 >= cards[i].start &&
						progress * 100 <= cards[i].stop
					) {
						card = cards[i];
						break;
					}
				}
				debounce = setTimeout(function () {
					$this.animate(
						{ scrollLeft: $this.find(".accordion-card").width() * card.i },
						250
					);
					history.replaceState(
						{},
						"",
						"#" + card.card.data("accordion-contents")
					);
					$this
						.parent(".accordion-body")
						.find(".more-accordion-contents *")
						.remove();
					$this
						.parent(".accordion-body")
						.find(".more-accordion-contents")
						.prepend(
							$(
								".accordion-contents-" + card.card.data("accordion-contents")
							).clone(true)
						);
				}, 250);
			});
			$this.find(".pic").click(function () {
				$this
					.parent(".accordion-body")
					.find(".more-container")
					.toggleClass("active");
				$this
					.parent(".accordion-body")
					.find(".more-container .more")
					.slideToggle();
				return false;
			});
		});
	}

	$("[data-instagram]").each(function () {
		$items = $(this).find(".items");
		moderated = $(this).data("instagram-moderated").split(",");
		var images = [];
		var todo = 0;

		var prepare = function (sources) {
			sources.split(",").forEach(function (source) {
				source = source.replace(/\s/g, "");
				var add = function (payload) {
					images = images.concat(payload.data);
					done();
				};
				if (source[0] === "#") {
					todo += 1;
					fetch(
						"https://api.instagram.com/v1/tags/" +
							source.replace("#", "") +
							"/media/recent",
						add
					);
				} else if (source[0] === "@") {
					todo += 1;
					fetch(
						"https://api.instagram.com/v1/users/search?q=" +
							source.replace("@", ""),
						function (payload) {
							var accountIndex = null;
							for (var i = 0; i < payload.data.length; i++) {
								if (
									payload.data[i].username.toLowerCase() ==
									source.replace("@", "").toLowerCase()
								) {
									accountIndex = i;
									break;
								}
							}
							if (accountIndex) {
								fetch(
									"https://api.instagram.com/v1/users/" +
										payload.data[accountIndex].id +
										"/media/recent",
									add
								);
							} else {
								$(".instagram-gallery").remove();
							}
						}
					);
				}
			});
		};

		var fetch = function (url, cb) {
			$.ajax({
				dataType: "jsonp",
				url: url,
				data: {
					access_token: "1090248051.1d1d36f.d24a1a83cfc14bb8b337245827769d42",
				},
				success: cb,
			});
		};

		var done = function () {
			todo -= 1;
			if (todo > 0) {
				return;
			}
			images
				.sort(function (a, b) {
					return parseInt(b.created_time, 10) - parseInt(a.created_time, 10);
				})
				.forEach(function (item) {
					if (moderated.indexOf(item.id) === -1) {
						$(
							'<a href="' +
								item.link +
								'" target="_blank" class="item" style="background-image: url(' +
								item.images.standard_resolution.url +
								');"></div>'
						).appendTo($items);
					}
				});
			if ($items.parents(".instagram-gallery").hasClass("gallery-left")) {
				$items.css(
					"width",
					($items.find(".item").length - 1) * 230 + 370 + "px"
				);
			} else {
				$items.css("width", $items.find(".item").length * 230 + "px");
			}
		};

		prepare($(this).data("instagram"));
	});

	var videoSize = 960;
	if ($(window).width() >= 500) {
		// videoSize = 1920;
		videoSize = 2544;
	}
	$(".video-banner-tilt-home").prepend(
		[
			"<video autoplay loop muted playsinline preload>",
			'<source src="//s3.amazonaws.com/denimandsteel/hcma/Tilt-WebHeader1-Website_' +
				videoSize +
				'.mp4" type="video/mp4">',
			'<source src="//s3.amazonaws.com/denimandsteel/hcma/Tilt-WebHeader1-Website_' +
				videoSize +
				'.webm" type="video/webm">',
			"</video>",
		].join("")
	);

	// $('.video-banner-tilt-air').prepend([
	//   '<video autoplay loop muted playsinline preload>',
	//     '<source src="//s3.amazonaws.com/denimandsteel/hcma/Tilt-WebHeader2-Website_' + videoSize + '.mp4" type="video/mp4">',
	//     '<source src="//s3.amazonaws.com/denimandsteel/hcma/Tilt-WebHeader2-Website_' + videoSize + '.webm" type="video/webm">',
	//   '</video>',
	// ].join(''));

	$(".postid-6773 .page-banner").addClass("has-video tilt-video");
	$(".postid-6773 .page-banner").prepend(
		[
			"<video autoplay loop muted playsinline preload>",
			'<source src="//s3.amazonaws.com/denimandsteel/hcma/Tilt-WebHeader2-Website_' +
				videoSize +
				'.mp4" type="video/mp4">',
			'<source src="//s3.amazonaws.com/denimandsteel/hcma/Tilt-WebHeader2-Website_' +
				videoSize +
				'.webm" type="video/webm">',
			"</video>",
		].join("")
	);

	// if ($(window).width() >= 600) {
	//   $('.tilt-video').prepend([
	//     '<video autoplay loop muted poster="/wp-content/uploads/2016/03/TILT_Shadow_Art_Loop.jpg">',
	//       '<source src="/wp-content/uploads/2016/03/TILT_Shadow_Art_Loop.mp4" type="video/mp4" />',
	//       '<source src="/wp-content/uploads/2016/03/TILT_Shadow_Art_Loop.webm" type="video/webm" />',
	//       '<source src="/wp-content/uploads/2016/03/TILT_Shadow_Art_Loop.ogv" type="video/ogg" />',
	//     '</video>'
	//   ].join(''));
	// }
	// if ($(window).width() < 600) {
	//   var $videoResizer = function() {
	//     if ($(window).width() >= 600) {
	//       $('.tilt-video').prepend([
	//         '<video autoplay loop muted poster="/wp-content/uploads/2016/03/TILT_Shadow_Art_Loop.jpg">',
	//           '<source src="/wp-content/uploads/2016/03/TILT_Shadow_Art_Loop.mp4" type="video/mp4" />',
	//           '<source src="/wp-content/uploads/2016/03/TILT_Shadow_Art_Loop.webm" type="video/webm" />',
	//           '<source src="/wp-content/uploads/2016/03/TILT_Shadow_Art_Loop.ogv" type="video/ogg" />',
	//         '</video>'
	//       ].join(''));
	//       $(window).unbind('resize', $videoResizer);
	//     }
	//   }
	//   $(window).resize($videoResizer);
	// }

	// Find a team member and navigate to them.
	if ($(".team-section").length > 0 && !!window.location.hash) {
		var $memberAnchor = $(
			'[data-member="' + window.location.hash.replace("#", "") + '"]'
		);
		if ($memberAnchor.length > 0) {
			if ($(window).width() <= 600) {
				var $memberParentAccordion = $memberAnchor.parents(".accordion");
				$memberParentAccordion.find(".accordion-header").click();
				$memberParentAccordion
					.find(".accordion-cards")
					.scrollLeft(
						$memberParentAccordion.find(".accordion-cards li").width() *
							$memberParentAccordion
								.find(".accordion-cards li")
								.index($memberAnchor.parent())
					);
				setTimeout(function () {
					$memberParentAccordion.find(".button-more").click();
				}, 200);
				$("html, body").animate(
					{
						scrollTop: $memberParentAccordion.find(".accordion-header").offset()
							.top,
					},
					250
				);
			} else {
				$memberAnchor.click();
				setTimeout(function () {
					$("html, body").animate(
						{
							scrollTop:
								$(".team-section").offset().top - $(".sub-nav").height(),
						},
						250
					);
				}, 250);
			}
		}
	}

	var $accordionTarget = $(
		'#publications [data-accordion-contents="' +
			window.location.hash.replace("#", "") +
			'"], #artists [data-accordion-contents="' +
			window.location.hash.replace("#", "") +
			'"]'
	);
	if ($(window).width() <= 600 && $accordionTarget.length > 0) {
		var $targetParentAccordion = $accordionTarget.parents(".accordion");
		$targetParentAccordion
			.find(".accordion-cards")
			.scrollLeft(
				$targetParentAccordion.find(".accordion-cards li").width() *
					$targetParentAccordion
						.find(".accordion-cards li")
						.index($accordionTarget.parent())
			);
		setTimeout(function () {
			$targetParentAccordion.find(".button-more").click();
		}, 200);
		$("html, body").animate(
			{ scrollTop: $targetParentAccordion.offset().top - 90 },
			250
		);
	}

	// Banner playback
	// $('<iframe src="https://www.youtube.com/embed/' + url.replace('https://www.youtube.com/watch?v=', '') + '?rel=0&controls=0&showinfo=0&modestbranding=1&autoplay=1" frameborder="0" allowfullscreen></iframe>').appendTo($slide);

	$(".slice-pop").each(function () {
		$slicePop = $(this);
		var initialContentHeight = $slicePop.find(".slice-four").height();

		var newsSlug = JSON.parse(Cookies.get("hcma-news") || "false");
		if ($slicePop.data("news") !== newsSlug) {
			$slicePop.addClass("available");

			var changeIndex = 0;
			var isBlackText = [false, true, false];
			setInterval(function () {
				$slicePop
					.find(".slice-changing .change:first-child")
					.appendTo($slicePop.find(".slice-changing"));
				$slicePop
					.find(".slices-text")
					.toggleClass(
						"has-black-text",
						isBlackText[++changeIndex % isBlackText.length]
					);
			}, 3000);

			$slicePop.find(".slice").click(function () {
				Cookies.set("hcma-news", JSON.stringify($slicePop.data("news")), {
					expires: 365,
				});
				if (!$slicePop.hasClass("active")) {
					$slicePop.addClass("active");

					var initialContentHeight = $slicePop.find(".slice-four").height();
					var iosHeightFix = function () {
						if (
							initialContentHeight >
							window.innerHeight - $(".site-header").height()
						) {
							$slicePop
								.find(".slice-four")
								.css("height", window.innerHeight - $(".site-header").height());
						} else {
							$slicePop.find(".slice-four").css("height", "auto");
						}
						$slicePop
							.find(".slice:not(.slice-four)")
							.css("height", $slicePop.find(".slice-four").height() - 5);
					};
					$(window).on("resize", iosHeightFix);
					iosHeightFix();

					// $slicePop.find('.slice:not(.slice-four)').css('height', initialContentHeight - 5);
					// $slicePop.find('.slices').css('transform', 'translateX(-0vw) rotate(-0deg)');
					return false;
				}
			});

			var closePop = function () {
				console.log($(window).height());
				$slicePop.addClass("closing");
				$slicePop
					.find(".slices")
					.css(
						"transform",
						"translateY(" + $slicePop.find(".slice-four").height() + "px)"
					);
				setTimeout(function () {
					$slicePop.remove();
				}, 1500);
				return false;
			};

			$slicePop.find(".slices-backdrop, .close").click(closePop);
			$(window).bind("keyup", function (e) {
				// ESC pressed.
				if (e.keyCode === 27 && $slicePop.hasClass("active")) {
					closePop();
				}
			});
		}
	});

	$("[data-hcma-instagram]").each(function () {
		var $this = $(this);
		var $images = $(this).find(".items");
		$.get("/wp-admin/admin-ajax.php?action=instagram_feed").then(function (
			data
		) {
			console.log(data);
			$.each(data["data"], function (i, image) {
				$this.show();
				$images.append(
					'<a href="' +
						image.link +
						'" class="item" target="_blank" style="background-image: url(' +
						image.images.standard_resolution.url +
						')"></a>'
				);
			});
		});
	});
});
